// extracted by mini-css-extract-plugin
export default {"root":"AdvancedReports_root__dR1MO","locked":"AdvancedReports_locked__VwwsG","modal":"AdvancedReports_modal__pe+8m"};